import { render, staticRenderFns } from "./CourseDetailed.vue?vue&type=template&id=699c605f&scoped=true&"
import script from "./CourseDetailed.vue?vue&type=script&lang=js&"
export * from "./CourseDetailed.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailed.vue?vue&type=style&index=0&id=699c605f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c605f",
  null
  
)

export default component.exports